import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BsSearch } from "react-icons/bs";
import { AiOutlineDelete } from "react-icons/ai";
import { AiFillEdit } from "react-icons/ai";
import IconButton from "@mui/material/IconButton";
import { useToast } from "../../components/ui/ToastContext";
import { FaRegCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import { API_URL } from "../../config";
import { logAuditUI } from "../../utils/auditLogger";

function DashboardCard15() {
  const { showToast } = useToast();

  const navigate = useNavigate();
  const [Data, setData] = useState([]);
  const [Data1, setData1] = useState([]);
  const [showGrid, setShowGrid] = useState(true); // Stare pentru a controla ce să afișezi
  const getJwtFromCookies = () => {
    const cookies = document.cookie.split("; ");
    const tokenCookie = cookies.find(row => row.startsWith("accessToken="));
    return tokenCookie ? tokenCookie.split("=")[1] : null;
  };
  //const token = getJwtFromCookies();

  const token = localStorage.getItem('jwtToken');


  useEffect(() => {
    const timer = setTimeout(() => {
      setShowGrid(false); // După 1 secundă, comutăm pe grid
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/producer`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setData(response.data);
        logAuditUI({
          actionType: 'VIEW_LIST',
          module: 'Producatori',
          description: 'A accesat lista de producători',
          details: { count: Array.isArray(response.data) ? response.data.length : 0 },
        });
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/repprod`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setData1(response.data)
        // //////////////////////////////////console.log(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  const fetchManageData = () => {
    axios
      .get(`${API_URL}/api/producer`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setData(response.data)
        // //////////////////////////////////console.log(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  };

  const [sortConfig, setSortConfig] = useState({
    key: 'producer_name', // Initial sorting key
    direction: 'ascending',   // Initial sorting direction
  });

  const sortedData = [...Data].sort((a, b) => {
    if (sortConfig.key && a[sortConfig.key] !== undefined && b[sortConfig.key] !== undefined) {
      const aValue = a[sortConfig.key] !== undefined ? a[sortConfig.key] : ''; // Default to empty string if undefined
      const bValue = b[sortConfig.key] !== undefined ? b[sortConfig.key] : ''; // Default to empty string if undefined

      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortConfig.direction === "ascending"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      } else if (typeof aValue === "number" && typeof bValue === "number") {
        return sortConfig.direction === "ascending" ? aValue - bValue : bValue - aValue;
      } else if (sortConfig.key === "district_name") {
        return sortConfig.direction === "ascending"
          ? new Date(aValue) - new Date(bValue)
          : new Date(bValue) - new Date(aValue);
      }
    }
    return 0;
  });

  const uniqueData = sortedData.reduce((acc, item) => {
    if (!acc.some(existingItem => existingItem.producer_name === item.producer_name)) {
      acc.push(item);
    }
    return acc;
  }, []);
  const [selecteduser, setSelecteduser] = useState(null);
  const [selecteddeleteuser, setSelecteddeleteuser] = useState(null);
  const [searchQuery1, setSearchQuery1] = useState('');
  const itemsPerPage = 15; // Schimbă după preferințe
  const [currentPage, setCurrentPage] = useState(1);
  const total = uniqueData.filter((user) => user.producer_name.toLowerCase().includes(searchQuery1.toLowerCase())
    || Data1.find(i => i.producer_group_id === user.producer_group_id && i.producer_group_name.toLowerCase().includes(searchQuery1.toLowerCase()))
  );
  const totalPages = Math.ceil(total.length / itemsPerPage);
  // Elemente curente pe baza paginii
  const currentItems = total.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    if (selecteddeleteuser) {
      ////////////////////////////////console.log("Selected user to delete:", selecteddeleteuser);  // Aici poți verifica ce conține userul selectat
      deleteRow();
    }
  }, [selecteddeleteuser]);

  useEffect(() => {
    if (selecteduser) {
      ////////////////////////////////console.log("Selected user to delete:", selecteduser);  // Aici poți verifica ce conține userul selectat
      handleNewRows1(selecteduser);
    }
  }, [selecteduser]);

  const handleNewRows = (item) => {
    ////////////////////////////////console.log(item);
    navigate("/producers/createproducer");
  };

  const handleNewRows1 = (item) => {
    ////////////////////////////////console.log(item);
    navigate("/producers/editproducer", { state: { item } });
  };

  const deleteRow = async () => {
    ////////////////////////////////console.log("selecteddeletecompany",);
    try {
      await axios.put(
        `${API_URL}/api/deleteproducer`,
        {
          producer_id: selecteddeleteuser.producer_id
        }
      );
      fetchManageData();
      showToast({
        message: "Datele au fost sterse cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      });
    } catch (error) {
      // console.error("Error saving changes:", error);
      showToast({
        message: "Eroare la ștergerea datelor! \nEste posibil ca datele să fie utilizate și de aceea nu se poate efectua ștergerea.",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  return (<div>
    {showGrid ? (
      <div className="flex flex-row gap-2">
        <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
        <div className="flex flex-col gap-2">
          <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
          <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
          <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
        </div>
      </div>
    ) : (
      <div className="col-span-full xl:col-span-8 bg-white dark:bg-gray-800 shadow-sm rounded-xl ">
        <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 ">
          <div className="lg:flex lg:items-center lg:justify-between d-flex flex-column flex-md-row justify-content-between align-items-start">
            <h2 className=" font-bold text-gray-800 dark:text-gray-100 mb-4 sm:mb-0 md:mb-0">Producatori</h2>
            <div className="sm:flex sm:items-center sm:gap-4 w-full sm:w-auto md:flex md:items-center md:gap-4 md:w-auto">
              <div className="relative w-full sm:w-64 md:w-80">
                <BsSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  className="pl-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 focus:border-blue-500 focus:outline-none dark:bg-gray-800 dark:text-gray-200 "
                  placeholder="Căutare"
                  value={searchQuery1}
                  onChange={(e) => setSearchQuery1(e.target.value)} />
              </div>

              <button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white mt-4 sm:mt-0"
                onClick={() => handleNewRows()}
              >
                <svg className="fill-current shrink-0 xs:hidden" width="16" height="16" viewBox="0 0 16 16">
                  <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                </svg>
                <span className="//max-xs:sr-only">Adauga</span>

              </button>
            </div>
          </div>
        </header>

        <div className="p-3" >
          {/* Table */}
          <div className="overflow-x-auto">
            <table className="table-auto w-full dark:text-gray-300">
              {/* Table header */}
              <thead className="text-xs uppercase text-gray-400 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                <tr>
                  <th className="p-2">
                    <div className="font-semibold text-left">Denumirea</div>
                  </th>
                  <th className="p-2">
                    <div className="font-semibold text-left">Grup</div>
                  </th>
                  <th className="p-2">
                    <div className="font-semibold text-center">Statut</div>
                  </th>

                  <th className="p-2">
                    <div className="font-semibold text-center">Actiune</div>
                  </th>
                </tr>
              </thead>
              {/* Table body */}
              <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
                {currentItems.map((customer, index) => {
                  return (
                    <tr
                      role="button"
                      key={customer.producer_id}
                      className={`${index % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"
                        } hover:bg-gray-200 dark:hover:bg-gray-600`}
                    >
                      <td className="p-2 whitespace-nowrap" onClick={() => setSelecteduser(customer)}>
                        <div className="text-left">{customer.producer_name}</div>
                      </td>
                      <td className="p-2 whitespace-nowrap" onClick={() => setSelecteduser(customer)}>
                        <div className="text-left">{Data1.find((i) => i.producer_group_id === customer.producer_group_id).producer_group_name}</div>
                      </td>

                      <td className="p-2 whitespace-nowrap" onClick={() => setSelecteduser(customer)}>
                        <div className={`text-center font-medium ${customer.is_active ? 'text-green-500' : 'text-red-500'}`}>
                          {customer.is_active ? "Activ" : "Inactiv"}
                        </div>
                      </td>

                      <td>
                        <div className="font-semibold text-center"
                          style={{
                            fontWeight: "bold",
                            fontSize: "20px"
                          }}
                        >
                          <IconButton
                            onClick={() => setSelecteduser(customer)}
                            color="primary"
                            sx={{
                              fontSize: "16px",
                              borderRadius: "50%",
                              "&:hover": {
                                backgroundColor: "#a4adad",
                              },
                            }}
                          >
                            < AiFillEdit className=" dark:text-gray-100" />
                          </IconButton>

                          <IconButton
                            onClick={() => setSelecteddeleteuser(customer)}
                            color="primary"
                            sx={{
                              fontSize: "16px",
                              borderRadius: "50%",
                              "&:hover": {
                                backgroundColor: "#a4adad",
                              },
                            }}
                          >
                            <AiOutlineDelete className=" dark:text-gray-100" />
                          </IconButton>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="flex justify-center mt-4">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-l-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
              disabled={currentPage === 1}
            >
              Prev
            </button>
            {currentPage > 3 && (
              <>
                <button
                  onClick={() => setCurrentPage(1)}
                  className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                >
                  1
                </button>
                <span className="px-2">...</span>
              </>
            )}

            {Array.from({ length: totalPages }, (_, index) => {
              const page = index + 1;

              if (
                page === currentPage ||
                // page === 1 ||
                // page === totalPages ||
                (page >= currentPage - 2 && page <= currentPage + 2)
              ) {
                return (
                  <button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className={`px-4 py-2 text-sm font-medium ${currentPage === page
                      ? "bg-gray-500 text-white"
                      : "bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                      }`}
                  >
                    {page}
                  </button>
                );
              }
              return null;
            })}

            {currentPage < totalPages - 2 && (
              <>
                <span className="px-2">...</span>
                <button
                  onClick={() => setCurrentPage(totalPages)}
                  className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                >
                  {totalPages}
                </button>
              </>
            )}

            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-r-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    )}</div>
  );
}

export default DashboardCard15;
